<mat-dialog-content class="dialog-content">
  <div class="modal-header">
    <p class="title">{{ data.title }}</p>
    <app-modal-close-button
      class="close-button"
      [closeDialog]="closeDialog.bind(this)"></app-modal-close-button>
  </div>
  <div class="modal-body">
    <p>{{ data.message }}</p>
    <div *ngFor="let department of data.products" style="margin-top: 10px">
      <p>Wohnbereich: {{ department.department.name }}</p>
      <ul style="margin-top: 5px">
        <li
          class="removed-item"
          *ngFor="let product of department.department.products"
          [innerHtml]="displayProduct(product)"></li>
      </ul>
    </div>

    <p style="margin-top: 20px" *ngIf="data?.residentInactive">
      Grund: Der Bewohner wurde von BringLiesel gesperrt.
    </p>

    <div style="display: flex; gap: 16px; justify-content: flex-end">
      <button
        *ngFor="let button of data.buttons"
        class="button"
        [ngStyle]="{ 'background-color': button.color }"
        (click)="button.closeDialog ? closeDialog() : performAction(button.id)">
        {{ button.text }}
      </button>
    </div>
  </div>
</mat-dialog-content>
